import { render, staticRenderFns } from "./TunnelDeposit.vue?vue&type=template&id=d95dc26a&scoped=true"
import script from "./TunnelDeposit.vue?vue&type=script&lang=js"
export * from "./TunnelDeposit.vue?vue&type=script&lang=js"
import style0 from "./TunnelDeposit.vue?vue&type=style&index=0&id=d95dc26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95dc26a",
  null
  
)

export default component.exports